<template>
  <div>
    <Modal
      :id="modalId"
      :title="`Request to join ${groupName}`"
      :buttonName="buttonTitle"
      :materialButton="true"
      @button="sendMessage"
      ref="modal"
      data-cy="modalRequestToJoin"
    >
      <p v-if="!result">
        {{
          `This message will go to ${getModeratorName(
            groupModerator
          )}, the moderator for ${groupName}`
        }}
      </p>
      <div
        class="spinner-border spinner-border-sm text-white m-auto"
        role="status"
        v-if="requesting"
      >
        <span class="sr-only">Loading...</span>
      </div>
      <span data-cy="requestToJoinResult" v-else>{{ result }}</span>
      <TextArea v-model="text" v-if="!requesting && !result" />
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/atoms/Modal";
import GroupHelperVue from "../../mixins/GroupHelper.vue";
import TextArea from "@/components/atoms/TextArea";
import UserHelperVue from "../../mixins/UserHelper.vue";
export default {
  name: "ModalNewJoinRequest",
  mixins: [GroupHelperVue, UserHelperVue],
  props: {
    requesting: { type: Boolean, default: false },
    result: null,
    buttonTitle: String,
    name: String,
    id: null,
  },
  components: {
    Modal,
    TextArea,
  },
  data() {
    return {
      text: "",
    };
  },
  computed: {
    defaultText() {
      if (!this.text && !this.result) {
        return `${this.getUserName(this.loggedUser)} is requesting to join ${
          this.groupName
        }`;
      } else if (this.text && !this.result) {
        return this.text;
      } else {
        return this.result;
      }
    },
    groupName() {
      if (this.name) return this.name;
      return this.getCurrentGroup.name;
    },
    groupModerator() {
      if (this.getModerator) return this.getModerator;
      return this.getCurrentGroup;
    },
    modalId() {
      let id = "join-request";
      if (this.id) {
        id += this.id;
      }
      return id;
    },
  },
  methods: {
    sendMessage() {
      if (this.buttonTitle === "Ok") {
        this.closeModal();
        window.location.reload();
        return;
      }
      if (!this.text) {
        this.$emit("joinrequest", this.defaultText);
      } else {
        this.$emit("joinrequest", this.text);
      }
    },
    closeModal() {
      this.$refs.modal.closeModal();
    },
  },
  beforeUpdate() {
    this.text = this.defaultText;
  },
};
</script>
